import React from 'react';
import { Box, Typography } from '@mui/material';
import { Logout } from '@mui/icons-material';
import SidebarNavItem from '../SidebarNavItem';
import ImageAvatar from 'ui-components/ImageAvatar';

const SidebarFooter = ({
  sidebarCollapsed,
  matchesUpMd,
  userAccess,
  accountName,
  accountLogo,
  accountLogoUpdatedAt,
  subtitle,
  menuConfig,
  handleLogOut,
  toggleDrawer,
}) => {
  // Mirrors the startup app: the account is the headline, the signed-in person
  // is the sub-line. Admins without a profile record fall back to just the name.
  const primaryLabel = accountName || userAccess?.userName;
  const secondaryLabel = accountName ? userAccess?.userName : subtitle;
  const commonProps = {
    drawerToggle: !matchesUpMd ? toggleDrawer : undefined,
    collapsed: sidebarCollapsed,
  };

  const bottomItems =
    menuConfig?.bottom?.filter((item) => item?.permission !== false) ?? [];

  return (
    <Box sx={{ flexShrink: 0 }}>
      {bottomItems.length > 0 && (
        <Box sx={{ px: '0', pb: '0.25rem' }}>
          {bottomItems.map((item) => (
            <SidebarNavItem key={item.label} {...item} {...commonProps} />
          ))}
        </Box>
      )}

      <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.1)', mx: '0.875rem' }} />

      {/* Identity only — there is nothing to switch to on admin, so the row is
          inert and the logout button beside it is the one affordance. */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.625rem',
          px: '0.875rem',
          py: '0.75rem',
          borderRadius: '6px',
          mx: '0.25rem',
          mb: '0.375rem',
          mt: '0.25rem',
        }}
      >
        <ImageAvatar
          height={'2.5rem'}
          width={'2.5rem'}
          style={{
            borderRadius: '9px',
            flexShrink: 0,
            width: '2.5rem',
            height: '2.5rem',
            cursor: 'default',
          }}
          src={accountLogo}
          updatedDate={accountLogoUpdatedAt}
          alt={primaryLabel || ''}
        />
        {!sidebarCollapsed && (
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              sx={{
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: 'white',
                lineHeight: 1.25,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {primaryLabel}
            </Typography>
            {secondaryLabel && (
              <Typography
                sx={{
                  fontSize: '0.6875rem',
                  fontWeight: 400,
                  color: 'rgba(255,255,255,0.55)',
                  lineHeight: 1.25,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {secondaryLabel}
              </Typography>
            )}
          </Box>
        )}
        {!sidebarCollapsed && (
          <Box
            onClick={handleLogOut}
            sx={{
              display: 'flex',
              alignItems: 'center',
              p: '0.25rem',
              borderRadius: '4px',
              color: 'rgba(255,255,255,0.45)',
              flexShrink: 0,
              cursor: 'pointer',
              transition: 'color 0.15s ease',
              '&:hover': { color: 'rgba(255,255,255,0.9)' },
            }}
          >
            <Logout sx={{ fontSize: '0.875rem' }} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default SidebarFooter;
